import { CoordinatorService } from "./coordinator.service"
import { TableCellInstance } from "./table-cell-instance"
import { TABLE_TYPE, TableInstance } from "./table-instance"
import { TableRow } from "./table-row"


export class TableRowInstance {
    cellLs: TableCellInstance[]


    constructor(private coords: CoordinatorService,
        public tbli: TableInstance, public tr: TableRow) {
        this.cellLs = tr.cellLs.map(c => new TableCellInstance(this.coords, this, c))

    }

    submitIsDisabled() {
        for (const r of this.cellLs) 
            if (r.submitIsDisabled())
                return true
        return false
    }

    edit() {
        this.tbli.edit({ focusRow: this })
    }

    get hasFocus() {
        return this.tbli.focusRow === this
    }

    get isEmpty() {
        return this.cellLs[0].isEmpty
    }

    get input() {
        return this.tbli.input
    }

    get title() {
        return this.tr.title
    }

    exportParams(): string[] {
        return this.cellLs.map(c => c.exportParams())[0]
    }

    confirmChanges() {
        this.cellLs.forEach(c => c.confirmChanges())
    }

    initEdit() {
        this.cellLs.forEach(c => c.initEdit())
    }

    get pin() {
        return {
            switch: () => this.switchPin(),
            has: () => this.hasPin
        }
    }

    get hasPin() {
        return this.tr.hasPin
    }

    switchPin() {
        return this.tr.switchPin()
    }

    get inEditOnly() {
        return this.tr.inEditOnly
    }

    get isHidden() {
        return this.tr.isHidden
    }

    getCell(row: string) {
        if (this.cellLs[0].tc.tag === row)
            return this.cellLs[0]
        return undefined
    }
}
